/**
 * Lucas withdrawn while the account is blocked for billing.
 *
 * Replaces the composer rather than disabling it: a greyed-out field still
 * reads as "try me", and `billingGate()` would answer 402 anyway. Same
 * footprint as the real box so the page doesn't reflow around the account's
 * billing state.
 */
export default function LucasRestricted({ restriction }) {
  const isExternal = /^https?:\/\//.test(restriction.href || "");

  return (
    <div className="flex min-h-[118px] flex-col items-center justify-center gap-2 rounded-[20px] border border-dashed border-black/15 bg-white/50 p-5 text-center backdrop-blur-[22px] dark:border-white/[.16] dark:bg-[#0e0e14]/40">
      <div className="text-[15px] font-bold leading-tight text-[#15161f] dark:text-white">
        {restriction.title}
      </div>
      <p className="m-0 text-[13.5px] leading-[1.45] text-[#5c5f70] dark:text-white/60">
        {restriction.detail}
      </p>
      {restriction.href && (
        <a
          href={restriction.href}
          {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
          className="mt-1 inline-flex h-[34px] items-center whitespace-nowrap rounded-[17px] bg-[#15161f] px-4 text-xs font-bold text-white no-underline transition-opacity hover:opacity-90 dark:bg-white dark:text-[#0a0a0f]"
        >
          {restriction.cta}
        </a>
      )}
    </div>
  );
}
